import { useEffect, useRef, useState } from "react";
import {
  LuMaximize2,
  LuMinimize2,
  LuMinus,
  LuPlus,
  LuSearch,
} from "react-icons/lu";
import {
  useProjectPreviewActions,
  useProjectPreviewScale,
} from "../../../view_stores/useProjectPreviewStore";

export function ProjectPreviewScaleControls() {
  const scale = useProjectPreviewScale();
  const { increaseScale, decreaseScale, resetScale } =
    useProjectPreviewActions();
  const [isHovered, setIsHovered] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout>();

  const handleMouseEnter = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    setIsHovered(true);
  };
  const handleMouseLeave = () => {
    timeoutRef.current = setTimeout(() => setIsHovered(false), 300);
  };
  useEffect(
    () => () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    },
    []
  );

  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col items-end justify-end">
      <div
        className="relative"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <button
          className="text-dark-text-muted hover:text-dark-text
          p-[10px] rounded-full shadow-lg
        hover:bg-dark-surface-secondary
        transition-colors
        flex items-center justify-center"
        >
          <LuSearch size={20} />
        </button>
        <div
          className={`absolute bottom-full right-0 mb-2 transition-all duration-300 ${
            isHovered
              ? "opacity-100 pointer-events-auto"
              : "opacity-0 pointer-events-none"
          }`}
        >
          <div
            className="flex items-center gap-2
          bg-dark-surface-secondary
          p-2 rounded-lg shadow-lg"
          >
            <ScaleBtn
              icon={<LuMinus size={16} />}
              isDisabled={scale <= 0.5}
              onClick={decreaseScale}
            />
            <ScaleBtn
              icon={
                scale > 1 ? (
                  <LuMinimize2 size={16} />
                ) : (
                  <LuMaximize2 size={16} />
                )
              }
              isDisabled={scale === 1}
              onClick={resetScale}
            />
            <ScaleBtn
              icon={<LuPlus size={16} />}
              isDisabled={scale >= 2}
              onClick={increaseScale}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

function ScaleBtn({
  icon,
  isDisabled,
  onClick,
}: {
  icon: React.ReactNode;
  isDisabled: boolean;
  onClick: () => void;
}) {
  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      className={`${
        isDisabled
          ? "opacity-50 cursor-not-allowed"
          : "hover:bg-dark-hover"
      } p-2 rounded-md transition-colors
      bg-dark-surface-secondary
      text-dark-text`}
    >
      {icon}
    </button>
  );
}
